// The full, unfiltered set of {value, text} options for each single-FDD brand select, captured
// before TomSelect takes over the <select> so it can be restored/filtered later. Keyed by select id.
const allBrandOptions = {};

// The single-FDD brand selects that can be narrowed by a checkbox. Each select carries the brand ids
// that pass its filter in data-filtered-brand-ids; `reset` clears whatever the section has on screen
// about an FDD when the chosen brand is filtered away.
const BRAND_FILTERS = [
  {
    select: 'fdd_brand_select',
    checkbox: 'fdd_unmapped_only',
    fddSelect: 'fdd_select',
    button: 'submit-fdd-to-horizon-button',
    reset: function () {
      $('#submit-fdd-to-horizon-result').empty();
      stopRun(SUBMIT_SECTION);
      $('#fdd-run-panel').hide();
    }
  },
  {
    select: 'identify_brand_select',
    checkbox: 'identify_unidentified_only',
    fddSelect: 'identify_fdd_select',
    button: 'identify-fdd-button',
    reset: function () { resetIdentitySection(); }
  }
];

// Callback function for when component loads. Called dynamically by callback in components.js
function initBrandDataManagementTool() {
  BRAND_FILTERS.forEach(function (filter) {
    const select = document.getElementById(filter.select);
    if (!select) return;

    allBrandOptions[filter.select] = Array.from(select.options)
      .filter(function (option) { return option.value; })
      .map(function (option) { return { value: option.value, text: option.text }; });
  });

  $('.it-tools-brand-data-management-tool-component select.tom-select').each(function () {
    if (this.tomselect) return;

    // Only render the removable-tag UI for actual multi-selects; single-selects (like
    // #fdd_brand_select) should look/behave like a plain dropdown, not a tag picker.
    const plugins = this.multiple ? ['remove_button'] : [];
    new TomSelect(this, { plugins: plugins, maxOptions: null });
  });

  BRAND_FILTERS.forEach(filterBrandSelect);
}

window.initBrandDataManagementTool = initBrandDataManagementTool;

// Narrow a single-FDD brand select to the brands its checkbox asks for: on Parse, brands with no FDD
// mapped/parsed to Horizon yet; on Identify, brands with an FDD Horizon has never identified.
function filterBrandSelect(filter) {
  const select = document.getElementById(filter.select);
  if (!select || !select.tomselect) return;

  const tomselect = select.tomselect;
  const allOptions = allBrandOptions[filter.select] || [];
  const filtered = $('#' + filter.checkbox).is(':checked');
  const filteredBrandIds = JSON.parse(select.dataset.filteredBrandIds || '[]').map(String);

  const visibleOptions = filtered
    ? allOptions.filter(function (option) { return filteredBrandIds.indexOf(option.value) !== -1; })
    : allOptions;

  const currentValue = tomselect.getValue();

  tomselect.clearOptions();
  tomselect.addOptions(visibleOptions);
  tomselect.refreshOptions(false);

  const currentValueStillVisible = visibleOptions.some(function (option) { return option.value === currentValue; });

  if (currentValue && !currentValueStillVisible) {
    tomselect.clear(true);
    $('#' + filter.fddSelect).prop('disabled', true).empty().append('<option value="">Choose a brand first...</option>');
    $('#' + filter.button).prop('disabled', true);
    filter.reset();
  }
}

$(document).on('change', '.it-tools-brand-data-management-tool-component #fdd_unmapped_only', function () {
  filterBrandSelect(BRAND_FILTERS[0]);
});

// On Identify the checkbox narrows the FDD list too, so a brand still selected is reloaded with it.
$(document).on('change', '.it-tools-brand-data-management-tool-component #identify_unidentified_only', function () {
  filterBrandSelect(BRAND_FILTERS[1]);
  const brandId = $('#identify_brand_select').val();
  if (brandId) {
    resetIdentitySection();
    loadFddsForBrand(brandId, 'identify_fdd_select', 'identify-fdd-button', 'identify-fdd-result', identifyFddParams());
  }
});

// Extra params for loading Identify's FDD list, per its "not yet identified" checkbox.
function identifyFddParams() {
  return { unidentified_only: $('#identify_unidentified_only').is(':checked') };
}

// When a brand is picked, load its FDDs that have a file attached into that section's FDD select.
// Shared by Submit and Identify, which differ only in which controls they drive.
function loadFddsForBrand(brandId, fddSelectId, buttonId, resultId, extraParams) {
  const $fddSelect = $('#' + fddSelectId);
  const $button = $('#' + buttonId);

  $('#' + resultId).empty();
  $fddSelect.prop('disabled', true).empty();
  $button.prop('disabled', true);

  if (!brandId) {
    $fddSelect.append('<option value="">Choose a brand first...</option>');
    return;
  }

  $fddSelect.append('<option value="">Loading FDDs...</option>');

  const params = $.extend({ brand_id: brandId }, extraParams || {});

  $.get('/components/it_tools/brand_data_management_tool/fdds', params).done(function (fdds) {
    $fddSelect.empty();

    if (!fdds.length) {
      const emptyLabel = params.unidentified_only ? 'No unidentified FDDs with a file attached' : 'No FDDs with a file attached';
      $fddSelect.append($('<option value=""></option>').text(emptyLabel));
      return;
    }

    $fddSelect.append('<option value="">Choose an FDD...</option>');
    fdds.forEach(function (fdd) {
      $fddSelect.append($('<option></option>').val(fdd.id).text(fdd.label));
    });
    $fddSelect.prop('disabled', false);
  }).fail(function () {
    $fddSelect.empty().append('<option value="">Failed to load FDDs</option>');
  });
}

$(document).on('change', '.it-tools-brand-data-management-tool-component #fdd_brand_select', function () {
  stopRun(SUBMIT_SECTION);
  $('#fdd-run-panel').hide();
  loadFddsForBrand($(this).val(), 'fdd_select', 'submit-fdd-to-horizon-button', 'submit-fdd-to-horizon-result');
});

$(document).on('change', '.it-tools-brand-data-management-tool-component #identify_brand_select', function () {
  resetIdentitySection();
  loadFddsForBrand($(this).val(), 'identify_fdd_select', 'identify-fdd-button', 'identify-fdd-result', identifyFddParams());
});

// Enable each section's button only once an actual FDD is chosen. Picking a different FDD also
// clears the previous one's output, so nothing on screen ever describes an FDD other than the one
// currently selected.
$(document).on('change', '.it-tools-brand-data-management-tool-component #fdd_select', function () {
  $('#submit-fdd-to-horizon-button').prop('disabled', !$(this).val());
  stopRun(SUBMIT_SECTION);
  $('#fdd-run-panel').hide();
});

$(document).on('change', '.it-tools-brand-data-management-tool-component #identify_fdd_select', function () {
  $('#identify-fdd-button').prop('disabled', !$(this).val());
  resetIdentitySection();
});

// Everything the Identify section has on screen about one FDD, cleared together - the comparison,
// the actions offered off it, and the run that produced them all describe a single FDD, so leaving
// any of them behind when the selection changes would describe the wrong one.
function resetIdentitySection() {
  stopRun(IDENTITY_SECTION);
  $('#identify-run-panel').hide();
  $('#identify-fdd-result').empty();
  $('#identify-fdd-actions').empty();
  $('#identify-fdd-apply-result').empty();
  lastFddIdentity = null;
}

// How long the browser keeps watching before it gives up and says so. Matches the gateway's own
// MAX_WAIT: past that the server-side wait has ended too, so there is nothing left to poll for.
const FDD_RUN_MAX_SECONDS = 60 * 60;

// The two watchable sections, each describing the panel it drives and how its run differs.
//
// Submit and Identify follow the same shape - submit, poll, report - but not the same run: a parse
// takes minutes and its result is the whole FDD, an identity takes seconds and its result is two
// fields to compare against the record. So the machinery below is shared and everything that
// actually differs lives here.
//
// `run` holds the one run in flight for that section. One at a time on purpose: the panel shows a
// single run, and a second submit replaces the first rather than interleaving two sets of statuses
// into one log.
const SUBMIT_SECTION = {
  prefix: 'fdd-run',
  button: '#submit-fdd-to-horizon-button',
  stopButton: '#stop-watching-fdd-button',
  statusUrl: '/components/it_tools/brand_data_management_tool/horizon_process_status',
  // Horizon moves between coarse stages ("Parsing the full FDD"), so there is nothing to see at a
  // finer grain - and a parse runs for minutes, which at a tighter interval would be hundreds of
  // round trips for the same handful of transitions.
  pollSeconds: 5,
  watchHeadline: 'Watching Horizon…',
  watchSubline: 'Diagnostic run — nothing will be written to Command Center.',
  importHeadline: 'Parsing and importing…',
  importSubline: 'The result will be merged into the brand when Horizon finishes.',
  run: null,
  lastStatus: null
};

const IDENTITY_SECTION = {
  prefix: 'identify-run',
  button: '#identify-fdd-button',
  stopButton: '#stop-watching-identity-button',
  statusUrl: '/components/it_tools/brand_data_management_tool/horizon_identity_status',
  // An identity read finishes in seconds rather than minutes, so poll tighter - at the parse's
  // interval the whole run would be over in one or two ticks and you'd see none of it.
  pollSeconds: 3,
  watchHeadline: 'Asking Horizon what this FDD is…',
  watchSubline: 'Diagnostic run — nothing will be written to Command Center.',
  run: null,
  lastStatus: null
};

// The raw result last fetched for the modal, kept so reopening it doesn't ask Horizon for the whole
// FDD again.
let lastFddResultJson = null;
let lastFddResultStatus = null;

function sectionEl(section, part) {
  return $('#' + section.prefix + '-' + part);
}

$(document).on('click', '.it-tools-brand-data-management-tool-component #submit-fdd-to-horizon-button', function () {
  const mode = $('input[name="fdd_submit_mode"]:checked').val() || 'watch';

  // An import rewrites the brand from whatever Horizon comes back with, so it asks first. A watch
  // run writes nothing and doesn't.
  if (mode === 'import' && !window.confirm(
    'Parse & import will merge Horizon\'s result into this brand and move the FDD\'s parse status. Continue?'
  )) {
    return;
  }

  startRun(SUBMIT_SECTION, {
    mode: mode,
    fddId: $('#fdd_select').val(),
    url: '/components/it_tools/brand_data_management_tool/submit_fdd_to_horizon',
    resultSelector: '#submit-fdd-to-horizon-result',
    startLog: 'Submitting the FDD to Horizon'
  });
});

$(document).on('click', '.it-tools-brand-data-management-tool-component #identify-fdd-button', function () {
  const mode = $('input[name="identify_mode"]:checked').val() || 'watch';

  if (mode === 'import' && !window.confirm(
    'Identify & re-file will correct this FDD\'s issuance date and move it to whichever brand the ' +
    'document names. Continue?'
  )) {
    return;
  }

  $('#identify-fdd-actions').empty();
  $('#identify-fdd-apply-result').empty();
  lastFddIdentity = null;

  startRun(IDENTITY_SECTION, {
    mode: mode,
    fddId: $('#identify_fdd_select').val(),
    url: '/components/it_tools/brand_data_management_tool/identify_fdd',
    resultSelector: '#identify-fdd-result',
    startLog: 'Asking Horizon what this FDD is'
  });
});

// Submits, then either follows the run or reports that it was handed off.
//
// Not every import is watchable, and that isn't an oversight: an identity import is done by a job
// that records nothing, so there is no status to follow. The server says which it was by whether it
// returns a process id or `queued`.
function startRun(section, options) {
  if (!options.fddId) return;

  const $button = $(section.button);
  const $result = $(options.resultSelector);

  stopRun(section);
  $button.prop('disabled', true);
  $result.empty();

  startRunPanel(section, options.mode);
  appendRunLog(section, options.startLog, 'text-muted');

  $.post(options.url, { fdd_id: options.fddId, mode: options.mode })
    .done(function (data) {
      if (!data.success) {
        failRun(section, data.errors, data.error_details);
        return;
      }

      if (data.queued) {
        finishQueuedRun(section, data);
        return;
      }

      section.run = {
        mode: data.mode,
        // A watch run is followed by its Horizon handle; a parse import by the FDD, because the
        // handle doesn't exist yet - the job writes it onto the row once Horizon acks the upload.
        processId: data.process_id,
        fddId: data.fdd_id,
        watchByFdd: data.mode === 'import' && !data.process_id,
        startedAt: Date.now(),
        lastLogKey: null,
        pollTimer: null,
        elapsedTimer: null
      };

      $(section.stopButton).show();
      appendRunLog(section, data.message, 'text-muted');
      section.run.elapsedTimer = setInterval(function () { renderRunElapsed(section); }, 1000);
      pollRun(section);
    })
    .fail(function (jqXHR) {
      failRun(section, 'Request to Command Center failed (HTTP ' + jqXHR.status + ')',
        { status_code: jqXHR.status, response_body: jqXHR.responseText });
    });
}

// A run that was handed to a background job rather than watched. There is nothing to poll, so the
// panel says what was started and stops there.
function finishQueuedRun(section, data) {
  stopRun(section);
  $(section.button).prop('disabled', false);
  sectionEl(section, 'headline').removeClass().addClass('fw-semibold text-success').text('Queued');
  sectionEl(section, 'subline').text('');
  appendRunLog(section, data.message, 'text-success');
}

$(document).on('click', '.it-tools-brand-data-management-tool-component #stop-watching-fdd-button', function () {
  stopWatching(SUBMIT_SECTION);
});

$(document).on('click', '.it-tools-brand-data-management-tool-component #stop-watching-identity-button', function () {
  stopWatching(IDENTITY_SECTION);
});

function stopWatching(section) {
  if (!section.run) return;

  // Only the watching stops. The work carries on at Horizon, and an import run will still finish
  // and write its result - so say that rather than implying it was cancelled.
  appendRunLog(section, 'Stopped watching. The run continues on Horizon\'s side.', 'text-warning');
  stopRun(section);
  $(section.button).prop('disabled', false);
}

// Reveals the panel and resets it to an empty run.
function startRunPanel(section, mode) {
  section.lastStatus = null;
  lastFddResultJson = null;
  lastFddResultStatus = null;

  sectionEl(section, 'log').empty();
  sectionEl(section, 'actions').empty();
  sectionEl(section, 'elapsed').text('0s');
  sectionEl(section, 'headline').removeClass().addClass('fw-semibold').text(
    mode === 'import' ? (section.importHeadline || 'Starting…') : section.watchHeadline
  );
  sectionEl(section, 'subline').text(
    mode === 'import' ? (section.importSubline || '') : section.watchSubline
  );
  sectionEl(section, 'panel').show();
}

// Clears the timers without touching what's on screen, so a finished run's panel stays readable.
function stopRun(section) {
  if (section.run) {
    if (section.run.pollTimer) clearTimeout(section.run.pollTimer);
    if (section.run.elapsedTimer) clearInterval(section.run.elapsedTimer);
  }
  section.run = null;
  $(section.stopButton).hide();
}

function pollRun(section) {
  const run = section.run;
  if (!run) return;

  // A parse import is followed by its row (the process id lives there); everything else by the
  // handle the submit returned. Identity sends both - the FDD is what its answer gets compared to.
  const params = run.watchByFdd ? { fdd_id: run.fddId } : { process_id: run.processId };
  if (section === IDENTITY_SECTION) params.fdd_id = run.fddId;

  $.get(section.statusUrl, params)
    .done(function (data) {
      if (!section.run) return;

      if (!data.success) {
        failRun(section, data.errors, data.error_details);
        return;
      }

      section.lastStatus = data;
      if (data.process_id) section.run.processId = data.process_id;

      renderRunStatus(section, data);

      if (data.finished) {
        finishRun(section, data);
        return;
      }

      scheduleNextPoll(section);
    })
    .fail(function (jqXHR) {
      if (!section.run) return;

      // A dropped poll says nothing about the run, so keep going rather than abandoning one that is
      // very likely still fine - the same reasoning the gateway's own poll loop uses.
      appendRunLog(section, 'Status check failed (HTTP ' + jqXHR.status + '), retrying…', 'text-warning');
      scheduleNextPoll(section);
    });
}

// The next tick, unless the run has outlasted the budget. Shared by both outcomes of a poll so a
// poll that keeps failing gives up on the same schedule a poll that keeps succeeding does - only
// checking the cap on success would leave a server that's down being retried forever.
function scheduleNextPoll(section) {
  if (!section.run) return;

  if ((Date.now() - section.run.startedAt) / 1000 >= FDD_RUN_MAX_SECONDS) {
    appendRunLog(section, 'Gave up watching after an hour. The run may still be going at Horizon.', 'text-warning');
    stopRun(section);
    $(section.button).prop('disabled', false);
    return;
  }

  section.run.pollTimer = setTimeout(function () { pollRun(section); }, section.pollSeconds * 1000);
}

// One poll's worth of state: the headline always reflects where things stand now, while the log
// below only grows when something actually changed.
function renderRunStatus(section, data) {
  const label = runStatusLabel(data);

  sectionEl(section, 'headline').removeClass().addClass('fw-semibold ' + runStatusClass(data)).text(label);

  const subline = [];
  if (data.process_id) subline.push('Process ' + data.process_id);
  if (data.import_parse_status_label) subline.push('Command Center: ' + data.import_parse_status_label);
  if (data.brand_name) subline.push('Horizon read: ' + data.brand_name);
  sectionEl(section, 'subline').text(subline.join(' · '));

  // Everything that would make this a new line in the log, so an unchanged poll adds nothing.
  const key = [data.status, data.progress, data.import_parse_status, data.error].join('|');
  if (key === section.run.lastLogKey) return;
  section.run.lastLogKey = key;

  appendRunLog(section, label, runStatusClass(data));

  if (data.error) appendRunLog(section, 'Horizon: ' + data.error, 'text-danger');
  if (data.import_error_message) appendRunLog(section, 'Command Center: ' + data.import_error_message, 'text-danger');
  if (data.known_status === false) {
    appendRunLog(section, 'Horizon reported a status this tool doesn\'t know: ' + data.status, 'text-warning');
  }
}

function runStatusLabel(data) {
  // Horizon's free-text progress is the most specific thing available, so it wins when there is one.
  if (data.progress) return data.progress;

  switch (data.status) {
    case 'submitting': return 'Uploading the FDD to Horizon';
    case 'pending': return 'Queued at Horizon';
    case 'processing': return 'Horizon is working on the FDD';
    case 'completed': return 'Horizon finished with the FDD';
    case 'failed': return 'Horizon failed on this FDD';
    case 'not_found': return 'Horizon found nothing to read';
    default: return 'Horizon status: ' + data.status;
  }
}

function runStatusClass(data) {
  if (data.status === 'failed' || data.import_parse_status === 'failed') return 'text-danger';
  if (data.status === 'not_found') return 'text-warning';
  if (data.status === 'completed') return 'text-success';
  return 'text-muted';
}

function appendRunLog(section, message, cssClass) {
  const stamp = new Date().toLocaleTimeString();
  const $log = sectionEl(section, 'log');

  $log.append('<div class="' + (cssClass || '') + '"><span class="text-muted">' + escapeHtml(stamp) +
    '</span> — ' + escapeHtml(message) + '</div>');

  // Pin to the newest line, which is the one worth looking at while a run is going.
  $log.scrollTop($log[0].scrollHeight);
}

function renderRunElapsed(section) {
  if (!section.run) return;

  const seconds = Math.floor((Date.now() - section.run.startedAt) / 1000);
  const text = seconds < 60 ? seconds + 's' : Math.floor(seconds / 60) + 'm ' + (seconds % 60) + 's';
  sectionEl(section, 'elapsed').text(text);
}

// A run that reached a terminal state. The raw result is worth seeing either way - a failure's
// response body is exactly what explains why - so the modal is offered whenever there is a process
// to read it from.
function finishRun(section, data) {
  renderRunElapsed(section);
  stopRun(section);
  $(section.button).prop('disabled', false);

  appendRunLog(section, 'Done.', runStatusClass(data));

  if (data.import_parse_status_label) {
    appendRunLog(section, 'Command Center finished as: ' + data.import_parse_status_label, runStatusClass(data));
  }

  // An identity run's payoff is the comparison against the record, not the JSON - so it renders
  // that inline and offers the raw response as the secondary thing.
  if (section === IDENTITY_SECTION) finishIdentityRun(data);

  if (!data.process_id) return;

  sectionEl(section, 'actions').append(
    '<button type="button" class="btn btn-sm btn-primary" data-run-prefix="' + section.prefix +
    '" data-process-id="' + escapeHtml(data.process_id) + '">View Horizon result</button>'
  );

  // A parse opens the modal straight away: finding out what came back is the reason it was watched.
  // An identity doesn't, because the comparison it just rendered already answers the question.
  if (section !== IDENTITY_SECTION) showFddResultModal(data.process_id, data);
}

function failRun(section, message, details) {
  stopRun(section);
  $(section.button).prop('disabled', false);
  sectionEl(section, 'headline').removeClass().addClass('fw-semibold text-danger').text('Failed');
  appendRunLog(section, message, 'text-danger');
  sectionEl(section, 'actions').html(
    '<a href="#" id="fdd-error-details-link" class="small">Show the full request and response</a>'
  );
  showFddErrorModal(message, details);
}

$(document).on('click', '.it-tools-brand-data-management-tool-component [data-process-id]', function () {
  const prefix = $(this).data('runPrefix');
  const section = prefix === IDENTITY_SECTION.prefix ? IDENTITY_SECTION : SUBMIT_SECTION;

  showFddResultModal($(this).data('processId'), section.lastStatus);
});

// An identity run's real answer: Horizon's reading beside the record, and whatever can be done about
// a disagreement. Rendered into the Identify section's own result area rather than the run panel,
// which is where the comparison lived before any of this was watched and where it still belongs.
function finishIdentityRun(data) {
  if (data.failed) return;

  lastFddIdentity = data;
  $('#identify-fdd-result').html(renderIdentity(data));
  renderIdentityActions(data);
}

// Horizon's response for a finished run: a summary of what it amounts to, then the body verbatim.
// Fetched on demand rather than carried on every poll - a completed parse is the whole FDD.
//
// `status` is the poll payload the result belongs to, so the summary can report Command Center's
// side alongside Horizon's. Held against the result being shown rather than against the last run to
// finish, since either section can open this modal.
function showFddResultModal(processId, status) {
  lastFddResultStatus = status || null;
  $('#fdd-result-modal-body').html('<div class="text-muted">Fetching the result from Horizon…</div>');
  $('#fdd-result-modal').modal('show');

  $.get('/components/it_tools/brand_data_management_tool/horizon_process_result', { process_id: processId })
    .done(function (data) {
      if (!data.success) {
        $('#fdd-result-modal-body').html('<div class="text-danger">' + escapeHtml(data.errors) + '</div>');
        return;
      }

      lastFddResultJson = JSON.stringify(data.body, null, 2);
      $('#fdd-result-modal-body').html(renderFddResult(data.body));
    })
    .fail(function (jqXHR) {
      $('#fdd-result-modal-body').html('<div class="text-danger">Couldn\'t fetch the result (HTTP ' +
        escapeHtml(jqXHR.status) + ').</div>');
    });
}

function renderFddResult(body) {
  body = body || {};

  const summary = [
    ['Status', body.status],
    ['Process ID', body.id],
    ['Brand Name', body.brand_name],
    ['Issuance Date', body.issuance_date],
    ['PDF', body.fdd_file_name],
    ['Progress', body.progress],
    ['Error', body.error]
  ].filter(function (row) { return row[1]; });

  // The import's own outcome belongs here too: Horizon completing and Command Center importing are
  // two different things, and a run can succeed at one and fail at the other.
  if (lastFddResultStatus && lastFddResultStatus.import_parse_status_label) {
    summary.push(['Command Center', lastFddResultStatus.import_parse_status_label]);
    if (lastFddResultStatus.import_error_message) {
      summary.push(['Import Error', lastFddResultStatus.import_error_message]);
    }
  }

  let html = '<dl class="row mb-0">' + summary.map(function (row) {
    return '<dt class="col-sm-3">' + escapeHtml(row[0]) + '</dt>' +
      '<dd class="col-sm-9 text-break">' + escapeHtml(row[1]) + '</dd>';
  }).join('') + '</dl>';

  html += renderFddResultIndex(body.result);

  // Capped rather than trimmed silently: a parsed FDD runs to megabytes of JSON, and pouring all of
  // it into the DOM locks the tab up. Copy and Download still hand over the whole thing.
  const RENDER_LIMIT = 400000;
  let shown = lastFddResultJson || JSON.stringify(body, null, 2);
  let truncated = false;

  if (shown.length > RENDER_LIMIT) {
    shown = shown.slice(0, RENDER_LIMIT);
    truncated = true;
  }

  html += '<h6 class="mt-3">Horizon Response</h6>';
  if (truncated) {
    html += '<div class="form-text text-warning mb-1">Showing the first ' + RENDER_LIMIT.toLocaleString() +
      ' characters. Use Copy or Download for the whole response.</div>';
  }
  html += '<pre class="bg-light p-2 border rounded text-break" style="white-space: pre-wrap; max-height: 28rem; overflow-y: auto;">' +
    escapeHtml(shown) + '</pre>';

  return html;
}

// What the parser actually filled in, section by section. The single most useful thing when an FDD
// "parsed" but came back thin: a row of empty items says where it went wrong far faster than
// scrolling the raw JSON does.
function renderFddResultIndex(result) {
  if (!result || typeof result !== 'object') return '';

  const keys = Object.keys(result);
  if (!keys.length) return '';

  return '<h6 class="mt-3">Result Sections</h6>' +
    '<table class="table table-sm mb-0"><thead><tr><th>Section</th><th>Contents</th></tr></thead><tbody>' +
    keys.map(function (key) {
      const value = result[key];
      const empty = value === null || value === undefined || value === '' ||
        (Array.isArray(value) && !value.length) ||
        (typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).length);

      return '<tr class="' + (empty ? 'table-warning' : '') + '">' +
        '<th scope="row">' + escapeHtml(key) + '</th>' +
        '<td>' + escapeHtml(empty ? 'empty' : describeFddResultValue(value)) + '</td>' +
        '</tr>';
    }).join('') + '</tbody></table>';
}

function describeFddResultValue(value) {
  if (Array.isArray(value)) return value.length + (value.length === 1 ? ' entry' : ' entries');
  if (typeof value === 'object') {
    const keys = Object.keys(value);
    return keys.length + (keys.length === 1 ? ' field' : ' fields');
  }
  return String(value).slice(0, 120);
}

$(document).on('click', '.it-tools-brand-data-management-tool-component #fdd-result-copy-button', function () {
  if (!lastFddResultJson) return;

  const $button = $(this);
  navigator.clipboard.writeText(lastFddResultJson).then(function () {
    $button.text('Copied');
    setTimeout(function () { $button.text('Copy JSON'); }, 2000);
  }).catch(function () {
    // The clipboard API is refused outright in some browser/permission setups, and without this the
    // button would just sit there looking like it worked. Download is the way out.
    $button.text('Copy blocked — use Download');
    setTimeout(function () { $button.text('Copy JSON'); }, 4000);
  });
});

$(document).on('click', '.it-tools-brand-data-management-tool-component #fdd-result-download-button', function () {
  if (!lastFddResultJson) return;

  const url = URL.createObjectURL(new Blob([lastFddResultJson], { type: 'application/json' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'horizon-' + ((lastFddResultStatus && lastFddResultStatus.process_id) || 'result') + '.json';
  link.click();
  URL.revokeObjectURL(url);
});

function escapeHtml(value) {
  return $('<div>').text(String(value == null ? '' : value)).html();
}

// The last identity Horizon returned, so the Apply buttons post back exactly what was on screen
// rather than re-reading it out of the rendered table.
let lastFddIdentity = null;

// What can actually be done about a disagreement, as buttons. Only differences get one: a field
// Horizon read that already matches the record has nothing to apply.
//
// Nothing here writes on its own - each button is a separate, confirmed action - because the
// identity check is routinely run on FDDs whose record is the correct one and whose *document* is
// the thing that's wrong.
function renderIdentityActions(data) {
  const $actions = $('#identify-fdd-actions');
  $actions.empty();

  if (!data.identified) return;

  const buttons = [];

  // The date can only be corrected if it's free. When another FDD on this brand already holds it,
  // this row isn't mis-dated - its file is that other filing, which makes its date and its parsed
  // items both wrong, and retiring it is the only thing on offer.
  if (data.misfiled_duplicate) {
    buttons.push('<button type="button" class="btn btn-sm btn-outline-danger me-2" id="retire-fdd-button">' +
      'Retire this FDD — its file is #' + escapeHtml(data.conflicting_fdd_id) + '</button>');
  } else if (data.issuance_date_iso && !data.issuance_date_matches) {
    buttons.push('<button type="button" class="btn btn-sm btn-outline-primary me-2" id="apply-issuance-date-button">' +
      'Set issuance date to ' + escapeHtml(data.issuance_date) + '</button>');
  }

  if (data.resolved_brand_id) {
    buttons.push('<button type="button" class="btn btn-sm btn-outline-primary me-2" id="apply-refile-button">' +
      'Re-file under ' + escapeHtml(data.resolved_brand_name) + '</button>');
  } else if (data.brand_name && !data.brand_name_matches) {
    // No plain name match, which is the interesting case rather than a dead end: "The Back 9" and
    // "The Back Nine" are the same brand and only the full resolver knows it. Offered as a button
    // because that resolver is slow and costs a model call.
    buttons.push('<button type="button" class="btn btn-sm btn-outline-secondary me-2" id="resolve-brand-button">' +
      'Find the brand "' + escapeHtml(data.brand_name) + '" belongs to</button>');
  }

  if (!buttons.length) return;

  $actions.html(buttons.join(''));
}

$(document).on('click', '.it-tools-brand-data-management-tool-component #apply-issuance-date-button', function () {
  if (!lastFddIdentity) return;

  if (!window.confirm('Set FDD #' + lastFddIdentity.fdd_id + "'s issuance date to " +
    lastFddIdentity.issuance_date + '?')) return;

  applyFddIdentity($(this), { fdd_id: lastFddIdentity.fdd_id, issuance_date: lastFddIdentity.issuance_date_iso });
});

$(document).on('click', '.it-tools-brand-data-management-tool-component #retire-fdd-button', function () {
  if (!lastFddIdentity) return;

  // Spelled out in full because this is the one action here that takes a row out of circulation -
  // and because what makes it safe (soft, restorable) is exactly what someone should know before
  // agreeing to it.
  if (!window.confirm(
    'Retire FDD #' + lastFddIdentity.fdd_id + '?\n\n' +
    'Horizon read its file as ' + lastFddIdentity.issuance_date + ', which this brand already holds ' +
    'as FDD #' + lastFddIdentity.conflicting_fdd_id + '. So this row\'s date and its 23 parsed items ' +
    'both came from a document that isn\'t its own.\n\n' +
    'It will be soft-deleted, not destroyed — nothing is lost and it can be restored.'
  )) return;

  const $button = $(this);
  const $result = $('#identify-fdd-apply-result');

  $button.prop('disabled', true);
  $result.html('<div class="text-muted">Retiring…</div>');

  $.post('/components/it_tools/brand_data_management_tool/retire_fdd',
    { fdd_id: lastFddIdentity.fdd_id, issuance_date: lastFddIdentity.issuance_date_iso })
    .done(function (data) {
      if (!data.success) {
        $result.html('<div class="text-danger">Error: ' + escapeHtml(data.errors) + '</div>');
        $button.prop('disabled', false);
        return;
      }

      $('#identify-fdd-actions').empty();
      $result.html('<div class="text-success">' + escapeHtml(data.message) + '</div>');
    })
    .fail(function (jqXHR) {
      $result.html('<div class="text-danger">Request failed (HTTP ' + escapeHtml(jqXHR.status) + ').</div>');
      $button.prop('disabled', false);
    });
});

$(document).on('click', '.it-tools-brand-data-management-tool-component #apply-refile-button', function () {
  if (!lastFddIdentity) return;

  if (!window.confirm('Move FDD #' + lastFddIdentity.fdd_id + ' from ' +
    (lastFddIdentity.recorded_brand_name || 'its current brand') + ' to ' +
    lastFddIdentity.resolved_brand_name + '?')) return;

  applyFddIdentity($(this), { fdd_id: lastFddIdentity.fdd_id, brand_id: lastFddIdentity.resolved_brand_id });
});

$(document).on('click', '.it-tools-brand-data-management-tool-component #resolve-brand-button', function () {
  if (!lastFddIdentity) return;

  const $button = $(this);
  const $result = $('#identify-fdd-apply-result');

  $button.prop('disabled', true);
  $result.html('<div class="text-muted">Looking for the brand this FDD belongs to…</div>');

  $.post('/components/it_tools/brand_data_management_tool/resolve_fdd_brand',
    { fdd_id: lastFddIdentity.fdd_id, brand_name: lastFddIdentity.brand_name })
    .done(function (data) {
      if (!data.success) {
        $result.html('<div class="text-danger">Error: ' + escapeHtml(data.errors) + '</div>');
        return;
      }

      if (data.already_filed_here) {
        $result.html('<div class="text-success">"' + escapeHtml(data.searched_name) +
          '" resolves to the brand this FDD is already filed under. Nothing to change.</div>');
        return;
      }

      if (!data.resolved_brand_id) {
        $result.html('<div class="text-warning">No Brand in Command Center matches "' +
          escapeHtml(data.searched_name) + '".</div>');
        return;
      }

      lastFddIdentity.resolved_brand_id = data.resolved_brand_id;
      lastFddIdentity.resolved_brand_name = data.resolved_brand_name;
      $result.html('<div class="text-info">Matched "' + escapeHtml(data.searched_name) + '" to ' +
        escapeHtml(data.resolved_brand_name) + '.</div>');
      renderIdentityActions(lastFddIdentity);
    })
    .fail(function (jqXHR) {
      $result.html('<div class="text-danger">Request failed (HTTP ' + escapeHtml(jqXHR.status) + ').</div>');
    })
    .always(function () {
      $button.prop('disabled', false);
    });
});

// Posts one confirmed change and reports what came back. The actions are cleared afterwards rather
// than left armed: what's on screen described the record before the write, so re-running the
// identity check is the honest way to see where things now stand.
function applyFddIdentity($button, params) {
  const $result = $('#identify-fdd-apply-result');

  $button.prop('disabled', true);
  $result.html('<div class="text-muted">Applying…</div>');

  $.post('/components/it_tools/brand_data_management_tool/apply_fdd_identity', params)
    .done(function (data) {
      if (!data.success) {
        $result.html('<div class="text-danger">Error: ' + escapeHtml(data.errors) + '</div>');
        $button.prop('disabled', false);
        return;
      }

      $('#identify-fdd-actions').empty();
      $result.html('<div class="text-success">' + escapeHtml(data.message) +
        ' Re-run Identify FDD to see the updated record.</div>');
    })
    .fail(function (jqXHR) {
      $result.html('<div class="text-danger">Request failed (HTTP ' + escapeHtml(jqXHR.status) + ').</div>');
      $button.prop('disabled', false);
    });
}

// Horizon's answer beside what Command Center has on record, so a disagreement is visible at a
// glance. An FDD that identified neither field isn't an error - it reads as "nothing found" - and
// one that gave up only half its identity says which half is missing.
function renderIdentity(data) {
  if (!data.identified) {
    return '<div class="text-warning">Horizon read ' + escapeHtml(data.filename) +
      ' but found neither a brand name nor an issuance date on its cover pages.</div>';
  }

  const rows = [
    ['Brand Name', data.brand_name, data.recorded_brand_name, data.brand_name_matches],
    ['Issuance Date', data.issuance_date, data.recorded_issuance_date, data.issuance_date_matches]
  ];

  // A field Horizon read that contradicts the record is a disagreement; one the record simply
  // doesn't have is a gap to fill. They read very differently to someone deciding what to do, so
  // they're never lumped together.
  const disagrees = function (row) { return row[1] && row[2] && !row[3]; };
  const fillsGap = function (row) { return row[1] && !row[2]; };

  let html = '<table class="table table-sm mb-0">' +
    '<thead><tr><th></th><th>Horizon Read</th><th>On Record</th></tr></thead><tbody>' +
    rows.map(function (row) {
      const highlight = disagrees(row) ? 'table-warning' : (fillsGap(row) ? 'table-info' : '');
      return '<tr class="' + highlight + '">' +
        '<th scope="row">' + escapeHtml(row[0]) + '</th>' +
        '<td>' + escapeHtml(row[1] || '—') + '</td>' +
        '<td>' + escapeHtml(row[2] || '—') + '</td>' +
        '</tr>';
    }).join('') + '</tbody></table>';

  const labelsOf = function (matching) {
    return rows.filter(matching).map(function (row) { return escapeHtml(row[0].toLowerCase()); });
  };

  const disagreed = labelsOf(disagrees);
  if (disagreed.length) {
    html += '<div class="text-warning mt-2">Horizon read a different ' + disagreed.join(' and ') +
      ' than this FDD is filed under.</div>';
  }

  const gaps = labelsOf(fillsGap);
  if (gaps.length) {
    html += '<div class="text-info mt-2">Command Center has no ' + gaps.join(' or ') +
      ' on record for this FDD.</div>';
  }

  if (!data.fully_identified) {
    const missing = data.brand_name ? 'an issuance date' : 'a brand name';
    html += '<div class="text-warning mt-2">Horizon could not read ' + missing +
      ' off the cover pages.</div>';
  }

  html += '<div class="form-text mt-1">File: ' + escapeHtml(data.filename) + '</div>';

  return html;
}

$(document).on('click', '.it-tools-brand-data-management-tool-component #fdd-error-details-link', function (event) {
  event.preventDefault();
  $('#fdd-error-modal').modal('show');
});

// Renders a detailed report of a failed Submit FDD request (status, request URL, response
// headers/body) in a modal, since the inline error message alone doesn't show what Horizon
// (or Command Center) actually returned.
function showFddErrorModal(message, details) {
  details = details || {};

  const prettyBody = function (body) {
    if (!body) return null;

    try {
      return JSON.stringify(JSON.parse(body), null, 2);
    } catch (e) {
      return body;
    }
  };

  const summaryRows = [['Message', message]];
  if (details.status_code) summaryRows.push(['Status Code', details.status_code]);
  if (details.reason_phrase) summaryRows.push(['Reason', details.reason_phrase]);
  if (details.request_url) summaryRows.push(['Request URL', details.request_url]);

  let html = '<dl class="row mb-0">' + summaryRows.map(function (row) {
    return '<dt class="col-sm-3">' + escapeHtml(row[0]) + '</dt><dd class="col-sm-9 text-break">' + escapeHtml(row[1]) + '</dd>';
  }).join('') + '</dl>';

  const responseBody = prettyBody(details.response_body);
  if (responseBody) {
    html += '<h6 class="mt-3">Response Body</h6>' +
      '<pre class="bg-light p-2 border rounded text-break" style="white-space: pre-wrap;">' + escapeHtml(responseBody) + '</pre>';
  }

  if (details.response_headers && Object.keys(details.response_headers).length) {
    html += '<h6 class="mt-3">Response Headers</h6>' +
      '<pre class="bg-light p-2 border rounded text-break" style="white-space: pre-wrap;">' + escapeHtml(JSON.stringify(details.response_headers, null, 2)) + '</pre>';
  }

  $('#fdd-error-modal-body').html(html);
  $('#fdd-error-modal').modal('show');
}
